import "./CollaboraUI.scss";
import { useEffect, useRef } from "react";

const CollaboraUI = ({ showCollabora, collaboraURL, setShowCollabora }) => {
    const iframeRef = useRef(null);
    useEffect(() => {
        if (!showCollabora && iframeRef.current) {
            // console.log("show coll");
            iframeRef.current.src = "about:blank";
        }
    }, [showCollabora]);
    const onClose = () => {
        setShowCollabora(false);
    };
    useEffect(() => {
        const handleMessage = (event) => {
            const collaboraOrigin = new URL(collaboraURL).origin;
            if (event.origin !== collaboraOrigin) {
                return;
            }
            const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
            if (data && typeof data === "object") {
                if (
                    data.MessageId === "close" ||
                    data.MessageId === "UI_Close" ||
                    data.MessageId === "Action_Close" ||
                    (data.MessageId === "Host_PostmessageReady" && data.Values && data.Values.close) ||
                    data.MessageId === "close_frame"
                ) {
                    onClose();
                }
            }
        };
        if (showCollabora) {
            window.addEventListener("message", handleMessage);
            const handleBeforeUnload = (e) => {
                onClose();
                return "";
            };
            window.addEventListener("beforeunload", handleBeforeUnload);
            return () => {
                window.removeEventListener("message", handleMessage);
                window.removeEventListener("beforeunload", handleBeforeUnload);
            };
        }

    }, [showCollabora, collaboraURL, onClose]);

    if (!showCollabora) return null;

    return (
        <div className="collabora">
            <iframe
                ref={iframeRef}
                src={`${collaboraURL}&closebutton=1`}
                style={{ border: 0, width: "100vw", height: "100vh" }}
            />
        </div>
    );
};

export default CollaboraUI;